"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionAdThemeColorSchemas = exports.PromotionAdSchema = exports.PromotionAdTheme = void 0;
const zod_1 = require("zod");
const __1 = require("..");
var PromotionAdTheme;
(function (PromotionAdTheme) {
    PromotionAdTheme["BaliHai"] = "BALI_HAI";
    PromotionAdTheme["Cerise"] = "CERISE";
    PromotionAdTheme["Christmas"] = "CHRISTMAS";
    PromotionAdTheme["CodGray"] = "COD_GRAY";
    PromotionAdTheme["Dixie"] = "DIXIE";
    PromotionAdTheme["FatalFury"] = "FATAL_FURY";
    PromotionAdTheme["GalleyGold"] = "GALLEY_GOLD";
    PromotionAdTheme["IrishCoffee"] = "IRISH_COFFEE";
    PromotionAdTheme["NewYear"] = "NEW_YEAR";
    PromotionAdTheme["PuertoRico"] = "PUERTO_RICO";
    PromotionAdTheme["SteelBlue"] = "STEEL_BLUE";
    PromotionAdTheme["Studio"] = "STUDIO";
    PromotionAdTheme["Sushi"] = "SUSHI";
    PromotionAdTheme["Tuscany"] = "TUSCANY";
    PromotionAdTheme["White"] = "WHITE";
    PromotionAdTheme["DingyDungeon"] = "DINGY_DUNGEON";
    PromotionAdTheme["BurntSienna"] = "BURNT_SIENNA";
    PromotionAdTheme["DarkPink"] = "DARK_PINK";
    PromotionAdTheme["AntiqueRuby"] = "ANTIQUE_RUBY";
    PromotionAdTheme["RadicalRed"] = "RADICAL_RED";
    PromotionAdTheme["OldLace"] = "OLD_LACE";
    PromotionAdTheme["LightPink"] = "LIGHT_PINK";
    PromotionAdTheme["JazzberryJam"] = "JAZZBERRY_JAM";
    PromotionAdTheme["CelestialBlue"] = "CELESTIAL_BLUE";
    PromotionAdTheme["BDazzledBlue"] = "BDAZZLED_BLUE";
    PromotionAdTheme["BeauBlue"] = "BEAU_BLUE";
    PromotionAdTheme["CelticBlue"] = "CELTIC_BLUE";
    PromotionAdTheme["RussianViolet"] = "RUSSIAN_VIOLET";
    PromotionAdTheme["EerieBlack"] = "EERIE_BLACK";
    PromotionAdTheme["Jet"] = "JET";
    PromotionAdTheme["ChineseBlack"] = "CHINESE_BLACK";
})(PromotionAdTheme || (exports.PromotionAdTheme = PromotionAdTheme = {}));
exports.PromotionAdSchema = __1.BaseSchema.extend({
    templateId: zod_1.z.string(),
    theme: zod_1.z.nativeEnum(PromotionAdTheme),
    customItemName: zod_1.z.string(),
    images: zod_1.z.array(zod_1.z.string()),
    promotionText: zod_1.z.string(),
    promotionTextColor: zod_1.z.nativeEnum(PromotionAdTheme),
    squareSerializedImageJson: zod_1.z.string().optional(),
    rectangularSerializedImageJson: zod_1.z.string().optional(),
    thumbnailSquareImageUrl: zod_1.z.string().url().optional(),
    thumbnailRectangularImageUrl: zod_1.z.string().url().optional(),
    squareImageUrl: zod_1.z.string().url().optional(),
    rectangularImageUrl: zod_1.z.string().url().optional(),
});
exports.PromotionAdThemeColorSchemas = {
    [PromotionAdTheme.FatalFury]: {
        primary: '#CD0C0C',
        secondary: '#CD0C0C66',
        text: '#CD0C0C',
    },
    [PromotionAdTheme.Tuscany]: {
        primary: '#CC5631',
        secondary: '#CC563166',
        text: '#CC5631',
    },
    [PromotionAdTheme.Dixie]: {
        primary: '#DAA315',
        secondary: '#DAA31566',
        text: '#4F3C0B',
    },
    [PromotionAdTheme.Sushi]: {
        primary: '#72B945',
        secondary: '#72B94566',
        text: '#2C5810',
    },
    [PromotionAdTheme.PuertoRico]: {
        primary: '#45B9AB',
        secondary: '#45B9AB66',
        text: '#125049',
    },
    [PromotionAdTheme.SteelBlue]: {
        primary: '#4581B9',
        secondary: '#4581B966',
        text: '#4581B9',
    },
    [PromotionAdTheme.Cerise]: {
        primary: '#E32A99',
        secondary: '#E32A9966',
        text: '#E32A99',
    },
    [PromotionAdTheme.Studio]: {
        primary: '#7145B9',
        secondary: '#7145B966',
        text: '#7145B9',
    },
    [PromotionAdTheme.IrishCoffee]: {
        primary: '#663227',
        secondary: '#66322766',
        text: '#663227',
    },
    [PromotionAdTheme.BaliHai]: {
        primary: '#8693B4',
        secondary: '#8693B466',
        text: '#394155',
    },
    [PromotionAdTheme.CodGray]: {
        primary: '#000000',
        secondary: '#00000066',
        text: '#000000',
    },
    [PromotionAdTheme.White]: {
        primary: '#FFFFFF',
        secondary: '#FFFFFF',
        text: '#FFFFFF',
    },
    [PromotionAdTheme.Christmas]: {
        primary: '#024220',
        secondary: '#02422066',
        text: '#024220',
    },
    [PromotionAdTheme.NewYear]: {
        primary: '#252C3B',
        secondary: '#252C3B66',
        text: '#252C3B',
    },
    [PromotionAdTheme.GalleyGold]: {
        primary: '#D6AA5E',
        secondary: '#D6AA5E66',
        text: '#9A6A2F',
    },
    [PromotionAdTheme.DingyDungeon]: {
        primary: '#CF2A55',
        secondary: '#FF96B366',
        text: '#CF2A55',
    },
    [PromotionAdTheme.BurntSienna]: {
        primary: '#EB8252',
        secondary: '#EB825266',
        text: '#EB8252',
    },
    [PromotionAdTheme.DarkPink]: {
        primary: '#E54A73',
        secondary: '#FF000066',
        text: '#E54A73',
    },
    [PromotionAdTheme.AntiqueRuby]: {
        primary: '#881823',
        secondary: '#88182366',
        text: '#E1223E',
    },
    [PromotionAdTheme.RadicalRed]: {
        primary: '#F73159',
        secondary: '#FFFFFF',
        text: '#F73159',
    },
    [PromotionAdTheme.OldLace]: {
        primary: '#FFF4E6',
        secondary: '#FFF4E666',
        text: '#E1223E',
    },
    [PromotionAdTheme.LightPink]: {
        primary: '#FBBAC2',
        secondary: '#FBBAC266',
        text: '#E1223E',
    },
    [PromotionAdTheme.JazzberryJam]: {
        primary: '#A1105E',
        secondary: '#A1105E66',
        text: '#E1223E',
    },
    [PromotionAdTheme.CelestialBlue]: {
        primary: '#468DCC',
        secondary: '#223B54',
        text: '#223B54',
    },
    [PromotionAdTheme.BDazzledBlue]: {
        primary: '#2F6292',
        secondary: '#223B54',
        text: '#223B54',
    },
    [PromotionAdTheme.BeauBlue]: {
        primary: '#C2D5F2',
        secondary: '#223B54',
        text: '#223B54',
    },
    [PromotionAdTheme.CelticBlue]: {
        primary: '#2A77BA',
        secondary: '#223B54',
        text: '#223B54',
    },
    [PromotionAdTheme.RussianViolet]: {
        primary: '#281242',
        secondary: '#28124266',
        text: '#281242',
    },
    [PromotionAdTheme.EerieBlack]: {
        primary: '#1D1D1D',
        secondary: '#1D1D1D66',
        text: '#1D1D1D',
    },
    [PromotionAdTheme.Jet]: {
        primary: '#363636',
        secondary: '#36363666',
        text: '#363636',
    },
    [PromotionAdTheme.ChineseBlack]: {
        primary: '#0B0D2A',
        secondary: '#0B0D2A66',
        text: '#0B0D2A',
    },
};
//# sourceMappingURL=ad.js.map